
/** Klíče pro překlady */
const LOCALE_KEYS = [
    "loading",
    "about",
    "tutorial",
    "send",
    "welcome",
    "onboarding",

    "your_nick",

    "you_can_start_anew",
    "welcome_back",
    "draw_something_special",

    "connected",
    "disconnected",
    "strange_noises",

    "blocked_notice",
    "rejected_notice",
    "accepted_notice",

    "about_you",
    "about_you_hint",

    "select_color",

    "anonymous_mode_notice",
    "connection_error",

    "too_short_notice",
    "too_small_notice",

    "your_drawing_was_submitted",
    "wait_to_show_on_facade",

    "sending_image_plese_wait"


] as const;

type LocaleKey = typeof LOCALE_KEYS[number];

/** Definice překladů pro 1 jazyk */
export type LocaleType = {
    [K in LocaleKey]: string;
}

/** Adresář klíčů pro překlady pro použití v komponentách */
export const T: Record<LocaleKey, string> = LOCALE_KEYS.reduce( (acc, curr) => {
    acc[curr] = curr;
    return acc;
}, {} as Record<LocaleKey, string> );

